import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/oz-leasing/intro_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={913}
              height={604}
            />
          </Col>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#2B8FE8" }}>Introduction</span>
            </h2>
            <p>
              We wanted to create a website that best reflects Oz’s business
              philosophy to keep things simple. We wanted to make sure that
              customers have a smooth trip, with increased engagement and
              satisfaction.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
